module.exports = __webpack_public_path__ + "76806f77f405d2eb3ba03337154e4d35.woff";